import React, { Component } from "react";

import {
    Button,
    Input,
    Row,
    Col,
    Card,
    CardBody,
    InputGroup,
    InputGroupAddon
} from "reactstrap";

import Registry from "../../Utils/Registry";


class PasswordResetForm extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.state = {
            loading: false,
            success: false,
            error: false,
            password: "",
            pass_check: "",
            token: null,
            tokenValid: false
        };
    }

    componentDidMount(){
        this.checkToken(this.props.token);
    }

    checkToken = token => {
        this.setState({loading: true, token: token});
        this.api.post("/customers/password/reset/check?token=" + token)
            .then(_ => {
                this.setState({tokenValid: true, loading: false});
            })
            .catch(_ => {
                this.setState({tokenValid: false, loading: false, error: "Le liens que vous avez utilisé n'est plus valide."});
            });
    };

    send = () => {
        if(this.state.token && this.state.tokenValid){
            if(this.state.password !== this.state.pass_check)
                this.setState({error: "Les deux mot de passe ne correspondent pas"});
            else{
                this.setState({success: false, loading: true, error: false});
                this.api.post("/customers/password/reset?token=" + this.state.token, {password: this.state.password})
                    .then(_ => {
                        this.setState({success: true, loading: false});
                    })
                    .catch(error => {
                        let msg = "Une erreur est survenue, merci de rééssayer d'ici quelques minutes. Si le problème persiste n'hesitez pas à nous contacter";
                        if (error.hasOwnProperty("subcode")) {
                            switch (error.subcode) {
                                case 'POSTCustomersInvalidPassword':
                                    msg = "Le mot de passe doit comporter au moins 6 caractères, une majuscule, un chiffre et une minuscule";
                                    break;
                                default:
                                    break;
                            }
                        }
                        this.setState({error: msg, loading: false});
                    });
            }
        }
    };

    render(){
        return <Row className="justify-content-center">
            <Col md="6">
                <Card className="p-4 border-rad-5">
                    {
                        !this.state.loading ?
                            <CardBody className="card-body">
                                {
                                    this.state.error !== false ?
                                        <Row>
                                            <Col xs="12" className={"center red " + (this.state.tokenValid ? "marg-b-20" : "")}>
                                                { this.state.error }

                                                { 
                                                    !this.state.tokenValid ?
                                                        <a className="display-block marg-t-20" href="/mot-de-passe-oublie">Refaire une demande</a>
                                                        : null
                                                }
                                            </Col>
                                        </Row>
                                        : null
                                }
                                {
                                    this.state.success !== false ?
                                        <Row>
                                            <Col xs="12" className="center green">
                                                Votre mot de passe &agrave; bien &eacute;t&eacute; mis &agrave; jour. 
                        
                                                <a className="display-block marg-t-20" href="/login">Vous connecter</a>
                                            </Col>
                                        </Row>
                                        : null
                                }
                                {
                                    this.state.tokenValid && !this.state.success ?
                                        <Row>
                                            <Col xs="12" className="center marg-b-20">
                                                Veuillez renseigner un nouveau mot de passe afin de vous connecter &agrave; votre compte.
                                            </Col>
                                        </Row>
                                        : null
                                }
                                {
                                    this.state.tokenValid && !this.state.success ?
                                        <InputGroup className="mb-4">
                                            <InputGroupAddon><i className="icon-lock" /></InputGroupAddon>
                                            <Input type="password" placeholder="Mot de passe ..." value={this.state.password} onChange={e => {this.setState({password: e.target.value })}} />
                                        </InputGroup>
                                        : null
                                }
                                {
                                    this.state.tokenValid && !this.state.success ?
                                        <InputGroup className="mb-4">
                                            <InputGroupAddon><i className="icon-lock" /></InputGroupAddon>
                                            <Input type="password" placeholder="Verification mot de passe ..." value={this.state.pass_check} onChange={e => {this.setState({pass_check: e.target.value })}} />
                                        </InputGroup>
                                        : null
                                }
                                {
                                    this.state.tokenValid && !this.state.success ?
                                        <Row>
                                            <Col xs="12" className="center">
                                                <Button className="uppercase px-4" color="primary" onClick={this.send}>
                                                    Mettre &agrave; jour
                                                </Button>
                                            </Col>
                                        </Row>
                                        : null
                                }
                            </CardBody>
                            :
                            <CardBody>
                                <Row>
                                    <Col xs="12" className="center">
                                        <i className="fa fa-spinner fa-spin fa-3x"></i><br /><br />
                                        Chargement ...
                                    </Col>
                                </Row>
                            </CardBody>
                    }
                </Card>
            </Col>
        </Row>;
    }
}

export default PasswordResetForm;



// WEBPACK FOOTER //
// ./src/components/Account/ResetPassForm.js